module.exports = __webpack_public_path__ + "static/media/ProductsIcon.28835331.svg";